import React from "react";
import { FormattedMessage } from 'react-intl';
import MenuListItemComponent from './navigation-list-item.js';
import $ from 'jquery';

export default class NavigationNestedList extends React.Component {

    constructor(props){
        super();

        this.state = {
            hasChildren: props.hasChildren || false,
            iconClassName :  props.iconClassName || '',
            defaultTranslation :  props.defaultTranslation || '',
            translationId :  props.translationId || '',
            children :props.children || [],
            toggle : props.toggle || false,
            path   : props.path
        }
    }

    handelOnclick(){
        if(this.state.hasChildren === false) return;
        this.setState({toggle : !this.state.toggle});
        $(this.subMenu).slideToggle(200);
    }

    render(){
        return (
            <li  className={(this.state.hasChildren === false ? "" : "sub-menu") + " " + (this.state.toggle === true ? "toggled" : "")}>
                <MenuListItemComponent  onClick={this.handelOnclick.bind(this)} path={this.state.path} hasChildren={this.state.hasChildren} iconClassName={ this.state.iconClassName } defaultTranslation={  this.state.defaultTranslation } translationId={ this.state.translationId } />
                <ul ref={(submenu) => this.subMenu = submenu}>
                    {this.state.children }
                </ul>
            </li>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/layouts/navigation-list-nest.js